import { initializeApp } from "@firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  MessagePayload,
  Messaging,
  onMessage,
} from "@firebase/messaging";
import { postUserFCMToken } from "../api/userDetails";

const firebaseConfig = {
  apiKey: "AIzaSyALiJrtvdqrZ65zoi3NbEuFITaG5jaO73Y",
  authDomain: "naturepreserve-ee0b1.firebaseapp.com",
  projectId: "naturepreserve-ee0b1",
  storageBucket: "naturepreserve-ee0b1.appspot.com",
  messagingSenderId: "729895157080",
  appId: "1:729895157080:web:4c6971c31fba40001a392d",
  measurementId: "G-FE5928X4QD",
};

export const messagingKey = "R-JWOPxDRSIa87YC887jNe-oNAlAjS4UIf1WjKtdv3E";

const firebaseApp = initializeApp(firebaseConfig);

class FirebaseMessagingService {
  private messaging: Messaging | null = null;

  constructor(private app = firebaseApp) {}

  async initialize(): Promise<Messaging | null> {
    const supported = await isSupported();
    this.messaging = supported ? getMessaging(this.app) : null;
    return this.messaging;
  }

  async requestPermission(): Promise<boolean> {
    try {
      const permission = await Notification.requestPermission();
      return permission === "granted";
    } catch (error) {
      console.error("Notification permission request failed:", error);
      return false;
    }
  }

  async handleToken(user: { fcmTokens?: string[] }): Promise<void> {
    if (!this.messaging) {
      console.warn("Messaging instance is not initialized.");
      return;
    }

    try {
      const token = await getToken(this.messaging);
      if (!user.fcmTokens || !user.fcmTokens.includes(token)) {
        await postUserFCMToken(token);
      }
    } catch (error) {
      console.error("Error retrieving FCM token:", error);
    }
  }

  listenForMessages(callback: (message: MessagePayload) => void): void {
    if (!this.messaging) {
      console.warn("Messaging instance is not initialized.");
      return;
    }

    onMessage(this.messaging, callback);
  }
}

export class NotificationSetupService {
  private messagingService: FirebaseMessagingService;

  constructor(messagingService: FirebaseMessagingService) {
    this.messagingService = messagingService;
  }

  async setup(
    user: { fcmTokens?: string[] },
    callback: (message: MessagePayload) => void
  ): Promise<void> {
    try {
      const messaging = await this.messagingService.initialize();
      if (!messaging) {
        console.warn("Firebase Messaging is not supported in this browser.");
        return;
      }

      const permissionGranted = await this.messagingService.requestPermission();
      if (!permissionGranted) {
        console.warn("Notification permission not granted.");
        return;
      }

      await this.messagingService.handleToken(user);
      this.messagingService.listenForMessages(callback);
    } catch (error) {
      console.error("Failed to set up notifications:", error);
    }
  }
}

const firebaseMessagingService = new FirebaseMessagingService();
const notificationSetupService = new NotificationSetupService(
  firebaseMessagingService
);

export { firebaseMessagingService, notificationSetupService };
